import React, { FC } from 'react';
import TextInput from '../TextInput';
import { SafeAreaView, TextInputProps } from 'react-native';
import styles from './styles';

type EmailInputProps = {
  errorMessage?: string | boolean;
  value: string;
  onBlur: Function;
  onChangeText: Function;
};

export type InputProps = EmailInputProps & TextInputProps;

export const EmailInput: FC<InputProps> = (props) => {
  const { errorMessage, onBlur, onChangeText, value } = props;
  return (
    <SafeAreaView>
      <TextInput
        autoCapitalize="none"
        autoCompleteType="email"
        autoCorrect
        errorMessage={errorMessage}
        imageKey={'email'}
        imageStyle={styles.imageStyle}
        keyboardType="email-address"
        label="Email"
        labelHidden
        onBlur={onBlur}
        onChangeText={onChangeText}
        placeholder="Email"
        value={value}
        textContentType="emailAddress"
      />
    </SafeAreaView>
  );
};

export default EmailInput;
